import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=3bac4a42&scoped=true&"
var script = {}
import style0 from "./Snackbar.vue?vue&type=style&index=0&id=3bac4a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac4a42",
  null
  
)

export default component.exports